export const VAULTISCAN_REQUEST_SOURCE = 'vaultiscan';

interface BuildVaultiscanHeadersOptions {
  customerId?: string | null;
  accept?: string;
  contentType?: string;
  headers?: Record<string, string | null | undefined>;
}

export const getApiBaseUrl = (): string => {
  return (window as any).__RUNTIME_CONFIG__?.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '';
};

export const buildVaultiscanHeaders = ({
  customerId,
  accept,
  contentType,
  headers = {},
}: BuildVaultiscanHeadersOptions = {}): Record<string, string> => {
  const requestHeaders: Record<string, string> = {
    'Request-Source': VAULTISCAN_REQUEST_SOURCE,
  };

  if (customerId) {
    requestHeaders['Customer-Id'] = String(customerId);
  }

  if (accept) {
    requestHeaders['Accept'] = accept;
  }

  if (contentType) {
    requestHeaders['Content-Type'] = contentType;
  }

  Object.entries(headers).forEach(([key, value]) => {
    if (value) {
      requestHeaders[key] = value;
    }
  });

  return requestHeaders;
};
